import { render, staticRenderFns } from "./WorkOrderStatusLegend.vue?vue&type=template&id=17936e94&scoped=true"
import script from "./WorkOrderStatusLegend.vue?vue&type=script&lang=js"
export * from "./WorkOrderStatusLegend.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderStatusLegend.vue?vue&type=style&index=0&id=17936e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17936e94",
  null
  
)

export default component.exports